import { observer } from "mobx-react"
import { useEffect } from "react"
import { BaseModal } from "../../../../common/components/BaseModal/BaseModal"
import { VaultUploadDragAndDropArea, VaultUploadBody, VaultUploadNotice, VaultUploadNoticeTitle, VaultUploadNoticeLink, VaultUploadNoticeDescription, VaultUploadDragAndDropAreaText, VaultUploadDragAndDropAreaDetails, VaultUploadDragAndDropAreaButton, VaultLoaderWrapper, UploadAnimatedBar, UploadAnimatedBarWrapper } from "./VaultUpload.styles"
import { VaultCopyIcon, VaultEmailIcon, VaultTypesIcon, VaultUploadIcon } from "../../assets/icons"
import { successNotification } from "../../../layout/components/Notifications/notifications"
import { useDropzone } from "react-dropzone"
import { useStore } from "../../../app/data/root.store"
import { MAX_VAULT_FILE_SIZE_MB, SUPPORTED_FILE_FORMATS } from "../Vault.const"
import { VaultModalHeader } from "../VaultModalHeader/VaultModalHeader"

export const VaultUpload = observer(({ onClose, createItemsState = false, files = null }) => {
    const { vaultStore, userStore } = useStore();

    useEffect(() => {
        if (files && files.length > 0) {
            const uploadFiles = async () => {
                await vaultStore.upload(files, [], { createItemsState });
                onClose();
            };
            uploadFiles();
        }
    }, [files, createItemsState, vaultStore, onClose]);

    const onCopyEmail = () => {
        navigator.clipboard.writeText('secure-import@vyzer.co');
        successNotification('Email copied')
    };

    const onDrop = async (acceptedFiles, rejectedFiles) => {
        await vaultStore.upload(acceptedFiles, rejectedFiles, { createItemsState });
        onClose();
    };

    const maxSizeInBytes = (MAX_VAULT_FILE_SIZE_MB * (2 ** 20));
    const isDropzoneDisabled = vaultStore.isUploading;
    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        maxSize: maxSizeInBytes,
        accept: SUPPORTED_FILE_FORMATS,
        disabled: isDropzoneDisabled,
        noClick: isDropzoneDisabled,
        noDrag: isDropzoneDisabled,
        noKeyboard: isDropzoneDisabled
    });

    const rootProps = getRootProps();
    const customRootProps = {
        ...rootProps,
        onDrop: (e) => {
            rootProps.onDrop && rootProps.onDrop(e);
        }
    };

    return (
        <BaseModal
            borderRadius={12}
            customModalWrapperStyles={{
                boxShadow: "0px 0px 2px 0px rgba(0, 0, 0, 0.30), 0px 4px 15px 0px rgba(0, 0, 0, 0.15)",
                flexShrink: 0,
                background: "#FFF"
            }}
            height={'auto'}
            noSidebarMargin={userStore.isWelcome}
        >
            <VaultModalHeader onClose={onClose} assetId={vaultStore.assetId} createItemsState={createItemsState} isCloseButtonDisabled={vaultStore.isUploading} />
            <VaultUploadBody>
                <VaultUploadDragAndDropArea
                    {...customRootProps}
                    isDragActive={isDragActive}
                >
                    <input {...getInputProps()} disabled={isDropzoneDisabled} />
                    <VaultUploadDragAndDropAreaDetails>
                        <VaultTypesIcon />
                        <VaultUploadDragAndDropAreaText>
                            <div>Drag and Drop Here:</div>
                            <div>Spreadsheet / K-1 / PFS / PPM etc.</div>
                        </VaultUploadDragAndDropAreaText>
                        {
                            isDropzoneDisabled ?
                                <VaultLoaderWrapper>
                                    <UploadAnimatedBarWrapper>
                                        <UploadAnimatedBar />
                                    </UploadAnimatedBarWrapper>
                                </VaultLoaderWrapper>
                                :
                                <VaultUploadDragAndDropAreaButton>
                                    <VaultUploadIcon />
                                    <div>Upload any financial document</div>
                                </VaultUploadDragAndDropAreaButton>
                        }
                    </VaultUploadDragAndDropAreaDetails>
                </VaultUploadDragAndDropArea>
                <VaultUploadNotice>
                    <VaultUploadNoticeTitle>
                        <VaultEmailIcon />
                        <div>Forward via email</div>
                    </VaultUploadNoticeTitle>
                    <VaultUploadNoticeDescription>
                        <div>
                            <div>Also, you can quickly and securely forward any financial</div>
                            <div>document you receive via email to your Vault.</div>
                        </div>
                        <VaultUploadNoticeLink>
                            <div>
                                <a href="mailto:secure-import@vyzer.co" style={{ color: 'inherit' }}>secure-import@vyzer.co</a>
                            </div>
                            <div onClick={onCopyEmail} style={{ cursor: 'pointer' }}><VaultCopyIcon /></div>
                        </VaultUploadNoticeLink>
                    </VaultUploadNoticeDescription>
                </VaultUploadNotice>
            </VaultUploadBody>
        </BaseModal>
    )
})